import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
	providedIn: 'root',
})
export class OnboardingTokenService {
	private readonly TOKEN_KEY = 'OnboardingToken';
	constructor(private localStorageService: LocalStorageService) {}

	createAndSaveOnboardingToken(): void {
		if (this.getOnboardingToken()) {
			return;
		}
		const token = uuidv4();
		this.localStorageService.save<string>(this.TOKEN_KEY, token);
	}

	getOnboardingToken(): string {
		return this.localStorageService.get<string>(this.TOKEN_KEY);
	}
}
